import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';

import App from './App';
import ShopProvider from './store/ShopProvider';

function Main() {
  return (
    <ShopProvider>
      <App />
    </ShopProvider>
  );
}

ReactDOM.render(<Main />, document.getElementById('root'));
